import React from 'react'
import { isDevelop, getInLocal, getValidCoupon } from '../../utils/app-helpers'
import GatsbyConfig from '../../../gatsby-config.js'

const { siteMetadata: config } = GatsbyConfig

export default class CouponField extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: '', isOpen: false, isValid: false }
  }

  componentDidMount() {
    const { trip } = this.props
    const { useCoupons, coupons } = config.trips[trip]
    const bookData = getInLocal('lsg.book-data', true)

    // trip has coupons disabled
    if (!useCoupons) return

    // check booking data for a valid coupon
    let validCoupon = getValidCoupon(bookData.coupon || '', coupons)

    // check utm coupon data
    if (!validCoupon) {
      const couponData = getInLocal(`lsg.coupon.${trip}`, true)

      if (couponData && couponData.code) {
        validCoupon = getValidCoupon(couponData.code, coupons)
      }
    }

    // automatically apply coupon if valid
    if (validCoupon) this.setCoupon(validCoupon.code);
  }

  componentDidUpdate() {
    if (this.refs.couponInput) this.refs.couponInput.focus()
  }

  showCouponField = () => {
    this.setState({ isOpen: true })
  }

  applyCoupon = () => {
    const { trip } = this.props
    const { coupons } = config.trips[trip]
    const coupon = this.refs.couponInput.value.toUpperCase()
    const matchedCoupon = getValidCoupon(coupon, coupons)

    if (!matchedCoupon) {
      this.setState({ error: 'Promo code is invalid.', isValid: false })
      return
    }
    this.setCoupon(coupon);
  }

  setCoupon = (coupon) => {
    try {
      const { onChange } = this.props;
      const data = JSON.parse(localStorage.getItem('lsg.book-data'))

      data.coupon = coupon
      localStorage.setItem('lsg.book-data', JSON.stringify(data))
      if (onChange) onChange(coupon)
      this.setState({ isOpen: false, isValid: true })
    } catch (err) {
      if (isDevelop) console.log(err)
      this.setState({ error: 'Unable to apply promo code.', isValid: false })
    }
  }

  removeCoupon = () => {
    const { onChange } = this.props

    if (onChange) onChange('')
    this.setState({ error: '', isValid: false, isOpen: false })
  }

  render() {
    if (typeof window === 'undefined') return <div />
    const { error, isOpen } = this.state
    const { trip, coupon } = this.props
    const { useCoupons, couponDisplay, coupons } = config.trips[trip]
    const bookData = getInLocal('lsg.book-data', true)
    const validCoupon = useCoupons && bookData.coupon
      ? getValidCoupon(bookData.coupon, coupons)
      : null
    const isValid = this.state.isValid || !!validCoupon

    return (
      <div className="coupon-field">
        {!isValid && !isOpen && couponDisplay === 1 && (
          <a onClick={this.showCouponField}>Promo Code</a>
        )}
        {(isOpen || (!isValid && couponDisplay > 1)) && (
          <p className={`field${couponDisplay === 2 ? ' short' : ''}`}>
            <input
              type="text"
              name="coupon"
              placeholder="Promo Code"
              autoComplete="off"
              maxLength="20"
              ref="couponInput"
              defaultValue={validCoupon ? validCoupon.code : ''}
            />
            <button onClick={this.applyCoupon}>Apply</button>
          </p>
        )}
        {!isValid && error && (
          <mark className="error">
            <i className="fa fa-cancel" /> {error}
          </mark>
        )}
        {isValid && (
          <mark className="success">
            Promo Code "{coupon}" Applied
            <a onClick={this.removeCoupon} aria-label="Remove Promo Code">
              <i className="fa fa-close" />
            </a>
          </mark>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/coupon-field.js